import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { lastValueFrom, map } from 'rxjs';
import {
  ProductVariantSummary,
  ShippingOrder,
  ShippingOrderControllerService,
  ShippingOrderRequestItem,
  ShippingOrderSubstitutionDetailResponse
} from 'src/app/admin-api';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-shipping-order-item-update-modal',
  templateUrl: './shipping-order-item-update-modal.component.html',
  styleUrl: './shipping-order-item-update-modal.component.scss'
})
export class ShippingOrderItemUpdateModalComponent implements OnInit {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);
  private shippingOrderService = inject(ShippingOrderControllerService);
  private product: ProductVariantSummary = this.config.data.product;
  private shippingOrder: ShippingOrder = this.config.data.shippingOrder;
  private shippingOrderItem: ShippingOrderRequestItem =
    this.config.data.shippingOrderItem;
  private;
  info: ShippingOrderSubstitutionDetailResponse;

  async ngOnInit() {
    if (!this.product || !this.shippingOrder || !this.shippingOrderItem) {
      console.error(
        'Please provide "product", "shippingOrder", and "shippingOrderItem" data.'
      );
      this.ref.close();
      return;
    }
    await this.findInfo();
  }

  async findInfo() {
    if (
      this.product?.productVariantId &&
      this.shippingOrderItem?.shippingOrderItemId
    )
      try {
        LoaderService.showLoader();
        this.info = await lastValueFrom(
          this.shippingOrderService
            .getSubstitutionDetails(
              this.shippingOrderItem.shippingOrderItemId,
              this.product.productVariantId
            )
            .pipe(map((data) => data.result))
        );
      } catch (error) {
        AppDialogService.showErrorDialog(error);
      } finally {
        LoaderService.showLoader(false);
      }
  }

  async submit() {
    try {
      LoaderService.showLoader();
      const items = await lastValueFrom(
        this.shippingOrderService
          .updateShippingOrderItemResend({
            productVariantId: this.product.productVariantId,
            shippingOrderItemId: this.shippingOrderItem.shippingOrderItemId,
            shippingOrderId: this.shippingOrder.shippingOrderId
          })
          .pipe(map((data) => data.result))
      );
      this.ref.close(items);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
      LoaderService.showLoader(false);
    }
  }

  get hasWarnings() {
    return this.info?.baldConflict || this.info?.received;
  }
}
